var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlayFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40588 4.53682C9.00592 4.29981 8.5 4.58808 8.5 5.05299V26.4339C8.5 26.8988 9.00592 27.1871 9.40588 26.9501L27.446 16.2596C27.8382 16.0272 27.8382 15.4597 27.446 15.2273L9.40588 4.53682Z",
    fill: "#F8F8F8",
    stroke: "#F8F8F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 5.31648V26.1709L26.8459 15.7437L9.25 5.31648ZM7.75 5.05323C7.75 4.00717 8.88832 3.35856 9.78823 3.89184L27.8284 14.5823C28.7107 15.1052 28.7107 16.3822 27.8284 16.9051L9.78823 27.5955C8.88832 28.1288 7.75 27.4802 7.75 26.4342V5.05323Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayFilled);
export default __webpack_public_path__ + "static/media/ic_play_filled.9b35338532110784be337a4c6b1a73b8.svg";
export { ForwardRef as ReactComponent };